/**
 * 使用范围
 * 车辆管理 -> 全部审批成功 -> 创建场次发拍
 * */
import { createStore } from '@souche-f2e/muji';
import API from '@/services';
import { getState, dispatch } from '@@/store';
import { setKey, getDataType } from '@/shared/functions';
import { notification } from 'antd';
// desc 产品线对应
const sessionKeyList = {
    1: 'XCP',
    2: 'APC',
    1001: 'CDP',
    1011: 'SUPER_XCP',
    1021: 'SUPER_CDP',
};
// desc 创建场次发拍数据
const createData = {
    query: {},
    roundType: 0,
    carData: [],
    carDataId: [],
    roundId: '',
    roundCode: '',
    roundStatus: null,
    superInDark: false,
    isDelayTender: false,
    formData: {
        auctionMode: 1,
        carAuctionDuration: 0,
        roundName: '',
        preStartDate: null,
        roundAddress: null,
        roundAddressId: null,
        frozenType: 1,
        roundDeposit: '',
        endTime: '',
        deadlineOfStartBidding: '',
        auctionPlayRuleId: null,
        commissionRuleId: null,
        brokerageRuleId: null,
    },
    roundPicUpload: '',
    imgList: [],
    sellerData: ['2', '3'],
    codePic: '',
    editIndex: false,
    editingKey: [],
    sessionList: [],
    loadingCar: false,
    defaultImgList: [
        'https://assets.souche.com/assets/sccimg/auctionSass/default1.png',
        'https://assets.souche.com/assets/sccimg/auctionSass/default2.png',
    ],
    systemDefaultImgList: [
        'https://assets.souche.com/assets/sccimg/auctionSass/default1.png',
        'https://assets.souche.com/assets/sccimg/auctionSass/default2.png',
    ],
};
// desc 添加车辆数据（modal）
const addCar = {
    showAddModal: false,
    addModalTable: [],
    addModalForm: {},
    addIndex: 0,
    addSize: 10,
    addTotal: 0,
};
const commonData = {
    rowKey: 'goodsId',
    pageState: null,
    outOfStock: false,
    roundPic: '',
    sessionAddress: [],
    validateList: {},
    validateIndexList: {},
};
const ruleData = {
    playRuleList: [],
    commissionRuleList: [],
    brokerageRuleList: [],
    ruleDefaultConfig: {
        sence: {},
        dark: {
            freezeDeposit: false,
        },
        car: {
            singleCarAuctionDuration: null,
        },
        superScene: {
            carAuctionDuration: null,
        },
        superCar: {
            singleCarAuctionDuration: null,
            singleTime: null,
        },
    },
};
export default createStore({
    state: Object.assign(Object.assign(Object.assign(Object.assign({}, createData), addCar), commonData), ruleData),
    effects: {
        // desc 获取配置图片
        getSessionImgList(params, { state }) {
            const { systemDefaultImgList } = state;
            API.user.getTenantInfoAndArea({})
                .then((res) => {
                const { tenantRoundImageVOList = [] } = res;
                const imgList = [];
                let defaultImg;
                if (tenantRoundImageVOList.length > 0) {
                    const defaultList = tenantRoundImageVOList.filter((item) => item.imageDefault === 1);
                    defaultList.length > 0 && (defaultImg = defaultList[0].imageUrl);
                    const otherList = tenantRoundImageVOList.filter((item) => item.imageDefault !== 1);
                    defaultImg && imgList.push(defaultImg);
                    otherList.forEach((item) => {
                        imgList.push(item.imageUrl);
                    });
                }
                imgList.push(...systemDefaultImgList);
                this.SET_STATE({
                    defaultImgList: imgList,
                    roundPic: defaultImg,
                });
            });
        },
        // desc 获取场次类型
        getRoundType() {
            API.base.getKeyValue({
                typeId: 28,
            })
                .then((res) => {
                this.SET_STATE({
                    sessionList: setKey(res),
                });
            });
        },
        // desc 获取佣金列表
        getBrokerageRuleList() {
            API.auction.getBrokerageList()
                .then((res) => {
                const { items } = res;
                this.SET_STATE({
                    brokerageRuleList: items,
                });
            });
        },
        // desc 获取服务费列表
        getCommissionRuleList() {
            API.auction.getCommissionList()
                .then((res) => {
                const { items } = res;
                this.SET_STATE({
                    commissionRuleList: items,
                });
            });
        },
        // desc 获取对应产品线玩法规则
        getPlayRuleList({ auctionMode, noDefault, callback }, { state }) {
            API.auction.getAuctionPlayRuleList({
                auctionMode: sessionKeyList[auctionMode],
            })
                .then((res) => {
                const { items } = res;
                const { formData } = state;
                const defaultPlayRule = items.filter((item) => item.defaultTag);
                formData.auctionPlayRuleId === null && (formData.auctionPlayRuleId = defaultPlayRule[0].id);
                this.SET_STATE({
                    playRuleList: items,
                    formData,
                });
            });
            !noDefault && this.getPlayRule({
                type: auctionMode,
                callback,
            });
        },
        // desc 获取产品线下默认玩法规则内容
        getPlayRule({ type, callback }, { state }) {
            API.auction.getAuctionPlayRule({
                auctionMode: sessionKeyList[type],
            })
                .then((res) => {
                this.dealAuctionRulePlayDefault({
                    res,
                    callback,
                });
            });
        },
        // desc 处理规则默认值
        dealAuctionRulePlayDefault({ res, callback }, { state }) {
            const { ruleDefaultConfig } = state;
            const ruleDefaultConfigNew = JSON.parse(JSON.stringify(ruleDefaultConfig));
            if (res) {
                switch (res.auctionMode) {
                    case 'APC':
                        ruleDefaultConfigNew.dark.freezeDeposit = res.frozenDepositTag === 0;
                        break;
                    case 'CDP':
                        ruleDefaultConfigNew.car.singleCarAuctionDuration = res.singleCarAuctionDuration;
                        break;
                    case 'SUPER_XCP':
                        ruleDefaultConfigNew.superScene.carAuctionDuration = res.carAuctionDuration;
                        break;
                    case 'SUPER_CDP':
                        ruleDefaultConfigNew.superCar.carAuctionDuration = res.carAuctionDuration;
                        ruleDefaultConfigNew.superCar.singleCarAuctionDuration = res.singleCarAuctionDuration;
                        break;
                }
            }
            this.SET_STATE({
                ruleDefaultConfig: ruleDefaultConfigNew,
                formData: Object.assign(Object.assign({}, state.formData), { auctionPlayRuleId: `${res.id}` }),
            });
            callback && callback();
        },
        // desc 更新规则
        updateRule({ params, callback }, { state }) {
            API.auction.updateRoundRule(Object.assign({ roundId: state.roundId }, params))
                .then(() => {
                const { formData } = state;
                formData.brokerageRuleId = params.brokerageRuleId;
                formData.commissionRuleId = params.commissionRuleId;
                this.SET_STATE({
                    formData,
                    editingKey: [],
                    validateList: {},
                });
                this.getGoodsDetail({});
            })
                .catch((err) => {
                console.log(err);
                const { formData } = state;
                err.code === '2154' && this.getBrokerageRuleList({});
                err.code === '2155' && this.getCommissionRuleList({});
                callback && callback({
                    brokerageRuleId: formData.brokerageRuleId || undefined,
                    commissionRuleId: formData.commissionRuleId || undefined,
                });
            });
        },
        // desc 改变玩法规则
        changeAuctionRule({ params, auctionMode, callback }, { state }) {
            // ToDo 更换接口
            API.auction.getAuctionPlayRuleById({
                id: params.auctionPlayRuleId,
            })
                .then((res) => {
                const { formData } = state;
                this.SET_STATE({
                    formData: Object.assign({}, formData, {
                        carAuctionDuration: res.carAuctionDuration,
                        singleCarAuctionDuration: res.singleCarAuctionDuration,
                    }),
                });
                this.freezeDeposit(auctionMode === 2 && res.frozenDepositTag === 0);
                callback && callback({
                    carAuctionDuration: res.carAuctionDuration,
                    singleCarAuctionDuration: res.singleCarAuctionDuration,
                    frozenDepositTag: auctionMode === 2 && res.frozenDepositTag === 0,
                });
            })
                .catch(() => {
                callback && callback({
                    auctionPlayRuleId: params.auctionPlayRuleId,
                });
            });
        },
        freezeDeposit(freeze, { state }) {
            this.SET_STATE({
                ruleDefaultConfig: Object.assign(Object.assign({}, state.ruleDefaultConfig), { dark: Object.assign(Object.assign({}, state.ruleDefaultConfig.dark), { freezeDeposit: freeze }) }),
            });
        },
        // desc 获取场次所在地
        getSessionPosition() {
            API.auction.getSessionAddress()
                .then((res) => {
                if (getDataType(res) === 'Array') {
                    const dealData = res.map((v) => {
                        return {
                            roundAddressNew: `${v.province || ''}${v.city || ''}${v.area || ''}${v.roundAddress}`,
                            roundAddress: v.roundAddress,
                            id: v.id,
                        };
                    });
                    this.SET_STATE({
                        sessionAddress: setKey(dealData),
                    });
                }
                else {
                    notification.warn({
                        message: '后端返回数据格式不正确',
                    });
                }
            });
        },
        // desc 修改表格中价格
        updatePrice(editData, { state }) {
            // FixMe 修改车辆价格 -> 成功后刷新表格数据（保留价，起拍价，服务费，佣金比） editPrice
            API.auction.editGoods(Object.assign(Object.assign({}, editData), { roundId: state.roundId }))
                .then((res) => {
                this.delEditKey(editData.goodsId);
                this.getGoodsDetail({
                    roundId: state.roundId,
                });
            });
        },
        // desc 移除车辆
        delCarFromTable(data, { state }) {
            const { editIndex } = state;
            // FixMe 移除拍品 -> 成功刷新表格数据 removeGoods
            editIndex ? notification.warn({
                message: '请先保存排序修改',
            }) : API.auction.removeGoods({
                goodsId: data['goodsId'],
                roundId: state.roundId,
            })
                .then((res) => {
                this.getGoodsDetail({
                    roundId: state.roundId,
                });
            });
        },
        // desc 上移车辆 or 下移车辆
        moveGoods(params, { state }) {
            const { editIndex } = state;
            if (editIndex) {
                notification.warn({
                    message: '请先保存排序修改',
                });
                return;
            }
            // FixMe 移动拍品顺序 -> moveGoods 刷新
            const { index, direction } = params;
            let moveIndex = null;
            let otherIndex = null;
            switch (direction) {
                case 'up':
                    moveIndex = index;
                    otherIndex = index - 1;
                    break;
                case 'down':
                    moveIndex = index + 1;
                    otherIndex = index;
                    break;
                default:
                    break;
            }
            const tableData = JSON.parse(JSON.stringify(state.carData));
            const moveItem = {
                auctionSerialNumber: tableData[moveIndex].auctionSerialNumber,
                goodsId: tableData[moveIndex].goodsId,
                roundId: state.query.id,
                id: tableData[moveIndex].id,
            };
            const otherItem = {
                auctionSerialNumber: tableData[otherIndex].auctionSerialNumber,
                goodsId: tableData[otherIndex].goodsId,
                roundId: state.query.id,
                id: tableData[otherIndex].id,
            };
            [moveItem.auctionSerialNumber, otherItem.auctionSerialNumber] =
                [otherItem.auctionSerialNumber, moveItem.auctionSerialNumber];
            API.auction.moveGoods({
                roundId: state.roundId,
                goodsIdOne: moveItem.goodsId,
                auctionSerialNumberOne: moveItem.auctionSerialNumber,
                roundGoodsIdOne: moveItem.id,
                goodsIdTwo: otherItem.goodsId,
                auctionSerialNumberTwo: otherItem.auctionSerialNumber,
                roundGoodsIdTwo: otherItem.id,
            })
                .then((res) => {
                this.getGoodsDetail({
                    query: state.query,
                });
            });
        },
        // desc 查询可添加车辆（表格数据）
        queryAddModalTable(query, { state }) {
            // FixMe 搜索可创建场次的车辆
            const { addSize, addModalForm } = state;
            const { pageIndex, params = null } = query;
            const lastQueryData = params || addModalForm;
            const queryParams = Object.assign({ pageNum: pageIndex, pageSize: addSize }, lastQueryData);
            API.goods.queryCar(queryParams)
                .then((res) => {
                const carData = res.items;
                this.SET_STATE({
                    addModalTable: carData,
                    addTotal: res.totalNumber,
                    addIndex: res.currentIndex,
                });
            });
        },
        // desc 车辆排序
        sortIndex(data, { state }) {
            let isEdit = false;
            const { carData, roundId } = state;
            const newCarData = carData.map((item) => {
                const { goodsId, auctionStatus, id } = item;
                let serialNum;
                if (`${goodsId}` in data) {
                    serialNum = Number(data[goodsId] || 0);
                }
                else {
                    serialNum = 0;
                }
                if (auctionStatus === 7) {
                    serialNum = false;
                }
                if (`${serialNum}` !== `${item.auctionSerialNumber}`) {
                    isEdit = true;
                }
                return {
                    serialNum,
                    goodsId,
                    id: id !== 'null' ? id : '',
                };
            });
            const editList = newCarData.filter((item) => {
                return item.serialNum !== false;
            });
            const params = {
                info: editList,
                roundId,
            };
            isEdit ?
                API.auction.editSerialNumber(params)
                    .then(() => {
                    this.SET_STATE({
                        editIndex: false,
                    });
                    this.getGoodsDetail({
                        roundId: state.roundId,
                    });
                }) :
                this.SET_STATE({
                    editIndex: false,
                });
        },
        // desc 添加车辆
        addModalDataToTable(edit, { state }) {
            const { idList } = edit;
            // FixMe 实时添加车辆
            API.auction.addGoodsList({
                goodsIds: JSON.stringify(idList),
                roundId: state.roundId || state.query.id,
            })
                .then((res) => {
                this.getGoodsDetail({
                    query: state.query,
                });
                this.SHOW_ADD_MODAL(false);
            });
        },
        // desc 创建场次
        createSession({ idList, routePath }) {
            // FixMe 创建场次->根据获取的场次id跳转创建场次发拍页面（后端创建，前端补充信息）
            // loading.show();
            API.auction.createSession({
                goodsIds: JSON.stringify(idList),
            })
                .then((res) => {
                this.SET_STATE({
                    roundId: res.roundId,
                    roundCode: res.roundCode,
                });
                dispatch.router.push({
                    path: routePath ? routePath : '/CarManage/AllApproveManage/CreateSession',
                    query: {
                        id: res.roundId,
                    },
                });
            });
        },
        // desc 发拍 or 保存
        uploadAuction(data, { state }) {
            // FixMe 发拍 -> 保存表单数据，车辆数据已实时保存
            // FixMe 保存 -> 保存表单数据，车辆数据已实时保存
            const { params, isSave, callback } = data;
            params['frozenType'] = params.frozenType === undefined ? 1 : params.frozenType;
            const saveData = Object.assign(Object.assign({}, params), { roundPic: state.roundPic, roundId: state.roundId, roundCode: state.roundCode });
            isSave ?
                API.auction.saveSession(Object.assign({}, saveData))
                    .then(() => {
                    notification.success({
                        message: '场次保存成功！',
                    });
                    callback && callback();
                })
                    .catch((err) => {
                    if (err.code === '2063') {
                        this.getPlayRuleList({
                            auctionMode: saveData.auctionMode,
                        });
                    }
                })
                :
                    API.auction.initiateAuction(Object.assign({}, saveData))
                        .then(() => {
                        notification.success({
                            message: '场次发拍成功！',
                        });
                        callback && callback();
                    })
                        .catch((err) => {
                        if (err.code === '2063') {
                            this.getPlayRuleList({
                                auctionMode: saveData.auctionMode,
                            });
                        }
                    });
        },
        // desc 重置添加车辆modal数据
        resetModal() {
            this.SET_STATE(Object.assign({}, addCar));
        },
        // desc 获取数据详情 创建，编辑，详情【创建逻辑，后端根据拍品创建场次，创建时修改已创建的场次】
        getSessionDetail(params, { state }) {
            this.SET_STATE({
                roundId: state.query.id,
            });
            API.auction.getSessionDetails({
                roundId: state.query.id,
            })
                .then((res) => {
                // FixMe 页面回填数据
                const formData = {
                    preStartDate: res.preStartDate && res.preStartTime ? `${res.preStartDate} ${res.preStartTime}` : '',
                    frozenType: res.frozenType,
                    roundAddress: res.roundAddress,
                    roundAddressId: res.roundAddressId,
                    roundDeposit: res.roundDepositY ? Number(res.roundDepositY).toFixed(0) : '',
                    roundName: res.roundName,
                    auctionMode: res.auctionMode || 1,
                    carAuctionDuration: res.carAuctionDuration,
                    deadlineOfStartBidding: res.deadlineOfStartBidding,
                    commissionRuleId: res.commissionRuleId,
                    auctionPlayRuleId: res.auctionPlayRuleId,
                    singleCarAuctionDuration: res.singleCarAuctionDuration,
                    brokerageRuleId: res.brokerageRuleId,
                    endTime: res.endTime,
                };
                const sellerData = JSON.parse(JSON.stringify(res.roundWhiteListDetailList || []).replace(/buyerName/g, 'label').replace(/buyerCode/g, 'value'));
                this.freezeDeposit(res.auctionMode === 2 && res.frozenDepositTag === 0);
                this.SET_STATE({
                    formData: Object.assign(state.formData, formData),
                    roundType: res.roundType,
                    roundId: res.roundId || state.query.id,
                    roundCode: res.roundCode,
                    roundStatus: res.status,
                    isDelayTender: res.isDelayTender === undefined ? false : res.isDelayTender,
                    superInDark: res.status === 5 || res.status === 1 || res.status === 0,
                    roundPic: res['roundPic'] ? res['roundPic'] : undefined,
                    roundPicUpload: res.status === 0 ? res['roundPic'] !== '' ? state.defaultImgList.includes(res['roundPic']) ? undefined : res['roundPic'] : createData.defaultImgList[0] : res['roundPic'],
                    sellerData,
                });
                const chekedValList = sellerData.map((v) => v.value);
                dispatch.searchDealers.SET_CHECKED_OPTIONS(sellerData || []);
                dispatch.searchDealers.SET_CHECKED_VALUES(chekedValList || []);
                res.auctionMode === 2 && res.status === 2 && this.isShowOutOfStock({
                    roundId: state.query.id,
                    auctionMode: res.auctionMode,
                });
                (res.auctionMode === 1011 || res.auctionMode === 1021) && res.status === 5 && this.isShowOutOfStock({
                    roundId: state.query.id,
                    auctionMode: res.auctionMode,
                });
                this.getPlayRuleList({
                    auctionMode: formData.auctionMode,
                    noDefault: res.auctionMode === 2,
                });
            });
            this.getGoodsDetail({
                roundId: state.roundId,
            });
        },
        // desc 请求发拍车辆数据
        getGoodsDetail(params, { state }) {
            const { rowKey } = state;
            // FixMe 请求发拍车辆数据
            this.SET_STATE({
                loadingCar: true,
            });
            API.auction.queryByRoundId({
                roundId: state.roundId || state.query.id,
            })
                .then((res) => {
                let tableKey = rowKey;
                if (res && res.length > 0 && res[0].auctionId !== 'null') {
                    tableKey = 'auctionId';
                    this.SET_STATE({
                        rowKey: tableKey,
                    });
                }
                const newData = res.map((item) => {
                    return Object.assign(Object.assign({}, item), { key: item[tableKey] });
                });
                this.SET_STATE({
                    carData: newData,
                });
            })
                .finally(() => {
                this.SET_STATE({
                    loadingCar: false,
                });
            });
        },
        // desc 切换页面状态【创建，详情，编辑】
        CHANGE_PAGE_STATE(pageState, { state }) {
            const create = JSON.parse(JSON.stringify(createData));
            pageState === 0 && delete create['carData'];
            const resetData = {
                pageState,
            };
            this.SET_STATE(resetData);
        },
        RESET_STATE(params, { state }) {
            this.SET_STATE(Object.assign(Object.assign(Object.assign(Object.assign({}, ruleData), createData), addCar), commonData));
        },
        // desc 获取场次二维码
        getPic(callback, { state }) {
            const params = {
                tenantCode: getState().userInfo.user.tenantCode || '',
                roundId: state.roundId,
            };
            API.auction.getMiniCode(params)
                .then((res) => {
                callback && callback(res);
            });
        },
        // desc 下架
        offShelf(data, { state }) {
            API.auction.takeOffAuctioningGoods({
                auctionId: data.auctionId,
            })
                .then(() => {
                this.getGoodsDetail({
                    query: state.query,
                });
            });
        },
        // desc 暗拍竞拍中是否开启下架
        isShowOutOfStock(params, { state }) {
            API.auction.selectTakeOff(params)
                .then((isShow) => {
                this.SET_STATE({
                    outOfStock: isShow,
                });
            });
        },
        checkCanOutOfStock({ auctionId }, { state }) {
            return API.auction.selectHigherBasePrice(auctionId);
        },
        isAuctionLast(params, { state }) {
            const { roundId } = state;
            return API.auction.isAuctionLast(roundId);
        },
        isTwoMinLeft(params, { state }) {
            const { roundId } = state;
            return API.auction.isTwoMinLeft(roundId);
        },
        // desc 暗拍竞拍中下架
        setAuctionFailed(auctionId) {
            API.auction.setAuctionFailed(auctionId)
                .then(() => {
                this.getGoodsDetail({});
            });
        },
        // desc 获取成交信息
        getTransfer(paramsData, { state }) {
            const { params, callback } = paramsData;
            API.goods.getCustomerServiceByGoodsId(params.goodsId)
                .then((msg) => {
                callback && callback(msg);
            });
        },
        // desc 导出场次表格
        exportOutSort(data, { state }) {
            // ToDo 调用接口导出数据
            API.auction.auctionExportSort({
                roundId: state.roundId,
                exportType: 'round_goods_export_sort_data',
            });
        },
        // desc 导入场次排序
        exportInSort(formData, { state }) {
            // ToDo 调用接口上传数据  成功后刷新表格数据
            API.auction.auctionLeadInSort(formData)
                .then(() => {
                this.SET_STATE({
                    editIndex: false,
                    validateIndexList: {},
                });
                this.getGoodsDetail({
                    roundId: state.roundId,
                });
            });
        },
    },
    reducers: {
        SET_STATE(state, payload) {
            Object.keys(payload)
                .forEach((key) => {
                if (typeof payload[key] !== 'undefined') {
                    state[key] = payload[key];
                }
            });
        },
        // desc 展示添加车辆Modal
        SHOW_ADD_MODAL(state, isShow) {
            state.showAddModal = (isShow !== undefined ? isShow : true);
        },
        addEditKey(state, key) {
            state.editingKey = [...state.editingKey, key];
        },
        delEditKey(state, key) {
            state.editingKey = state.editingKey.filter((i) => i !== key);
        },
    },
});
